/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ArgosFlexbox from '../../Containers/ArgosFlexbox';
import {ITableProps} from '../constants';
import { MRT_ColumnDef} from 'material-react-table'
import {useMemo, useState} from 'react';
import { tableHeaderGray } from '../../../../constants/colors';
import {ArgosTableSimple} from "../../Table/ArgosTableSimple";


/**
 * Renders a Table collapse section in the FullReport view.
 * Accepts any column and row configuration.
 */
const Table = (props: ITableProps) => {
  const tableData = props.data
  const [data, setData] = useState<any>(tableData.rows)

  const columns: MRT_ColumnDef<any>[] = useMemo(() => {
    let _columns: MRT_ColumnDef<any>[] = []
    tableData.columns.forEach((column: string) => {
      _columns.push({
        id: column,
        header: column,
        accessorKey: column,
        enableEditing: false,
        minSize: 80,
        size: 340,
      })
    })
    return _columns
  }, [tableData])

  const stickyColumns = useMemo(() => tableData.config?.stickyColumns ?? [], [tableData.config])

  return(
    <ArgosFlexbox vertical style={{overflow: "auto", padding: 10}}>
      <ArgosTableSimple 
        columns={columns}
        data={data}


        enableColumnPinning={true}
        initialState={{density: 'compact', columnPinning: {left: stickyColumns}}} // TODO: Should this work like front pages, saving to db?

        enableBottomToolbar={true}
        enablePagination={true}
        enableTopToolbar={false}
        muiTableContainerProps={{ sx: { maxHeight: 700} }}
        muiTableBodyCellProps={({column}) => {
          return ({sx: {
            backgroundColor: stickyColumns.includes(column.id) ? tableHeaderGray : undefined,
            fontWeight: stickyColumns.includes(column.id) ? 'bold' : 'normal',
          },
        })}}
      />
    </ArgosFlexbox>
  )
}

export default Table
